export default "/_next/static/images/70cc257289b195a8de3aeea8696f6c65.jpg";